import { useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import geoData from "../data/turkey-provinces.json";

const norm = (s) => (s || "").toString().toUpperCase()
  .replace(/İ/g, "I").replace(/I/g, "I").replace(/Ş/g, "S").replace(/Ç/g, "C")
  .replace(/Ğ/g, "G").replace(/Ü/g, "U").replace(/Ö/g, "O")
  .replace(/[^A-Z0-9]/g, "").trim();

const fmt = (n) => (n || 0).toLocaleString("tr-TR", { maximumFractionDigits: 1 });

export default function TurkeyMap({ provinces = [] }) {
  const [hover, setHover] = useState(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const map = {};
  provinces.forEach((p) => { map[norm(p.province)] = p; });
  const maxMwm = Math.max(1, ...provinces.map((p) => p.mwm || 0));

  const dataFor = (name) => {
    const n = norm(name);
    if (map[n]) return map[n];
    return Object.values(map).find((v) => {
      const b = norm(v.province);
      return n && b && (n.includes(b) || b.includes(n));
    }) || null;
  };

  const colorFor = (name) => {
    const d = dataFor(name);
    if (!d) return "#eef2f7";
    if (!d.mwm) return "#cfe3f5";  // projesi var ama kapasite girilmemiş → açık mavi
    const t = Math.min(1, d.mwm / maxMwm);
    const lerp = (a, b) => Math.round(a + (b - a) * t);
    return `rgb(${lerp(253, 146)}, ${lerp(224, 64)}, ${lerp(180, 14)})`;
  };

  return (
    <div className="turkey-map-wrap" onMouseMove={(e) => setPos({ x: e.clientX, y: e.clientY })} data-testid="turkey-map">
      <ComposableMap projection="geoMercator" projectionConfig={{ center: [35.3, 39.05], scale: 2350 }} width={820} height={360} style={{ width: "100%", height: "auto" }}>
        <Geographies geography={geoData}>
          {({ geographies }) => geographies.map((geo) => {
            const name = geo.properties.name;
            return (
              <Geography key={geo.rsmKey} geography={geo}
                fill={colorFor(name)} stroke="#ffffff" strokeWidth={0.6}
                onMouseEnter={() => setHover({ name, d: dataFor(name) })}
                onMouseLeave={() => setHover(null)}
                style={{
                  default: { outline: "none" },
                  hover: { outline: "none", fill: "#0284c7", cursor: "pointer" },
                  pressed: { outline: "none" },
                }}
              />
            );
          })}
        </Geographies>
      </ComposableMap>

      {hover && (
        <div className="map-tooltip" style={{ left: pos.x + 14, top: pos.y + 14 }} data-testid="map-tooltip">
          <b>{hover.name}</b>
          {hover.d ? (
            <><span>{hover.d.project_count} proje</span><span className="tt-mw">{fmt(hover.d.mwm)} MWm</span></>
          ) : <span>Proje yok</span>}
        </div>
      )}

      <div className="map-legend">
        <span>Düşük</span><i className="map-grad" /><span>Yüksek kurulu güç (MWm)</span>
      </div>
    </div>
  );
}
